import React from "react";

export default function Bundles(props) {
    const { bundleConfig, bundles, getBundle, readOnly } = props;
    if (readOnly) return null;
    if (bundleConfig && bundleConfig.customization && bundleConfig.customization.enabled && bundleConfig.customization.list){
        return (
            <div className="bundles">
                {
                    bundles.map((bundle) => {
                        if(bundle.FilledChildren) return null;
                        let bundleOfImage = bundleConfig.customization.list.find(b => bundle.BundleName.indexOf(b.name) >= 0)
                        return (
                            <div 
                                style={bundleOfImage ? { backgroundImage: `url(${bundleOfImage.image })` }: null} 
                                onClick={()=>getBundle(bundle)} 
                                className="bundle item"
                            >
                                <span>[ + ] {bundle.BundleName}</span>
                            </div>
                        )
                    })  
                } 
            </div>
        )
    } 
    return (
        bundles.map((bundle, idx) => {
            if (bundles.find((bund, index) => { return bund.BundleId === bundle.BundleId && index < idx && bund.FilledChildren === 0 })) return null;
            if(bundle.FilledChildren) return null;
            return (
                <div onClick={()=>getBundle(bundle)} className="bundle item">
                    [ + ] {bundle.BundleName}
                </div>
            )
        })  
    )
}